const local = {
  API: {
    AUTH: 'https://localhost:44396/api',
    DATA: 'https://localhost:44396/api'
    }, 
    ORIGINS: ['http://localhost:5173', 'https://localhost:5173', 'http://localhost:5174', 'https://localhost:5174'],
    CLIENTAPP: ['http://localhost:5174']
}

const dev = {
  API: {
        AUTH: 'https://localhost:44396/api',
        DATA: 'https://localhost:44396/api'
    }, 
    ORIGINS: ['http://localhost:5173', 'https://localhost:5173', 'http://localhost:5174', 'https://localhost:5174', 'https://app.lowquotes.ie', 'https://hello.lowquotes.ie'],
    CLIENTAPP: ['http://localhost:5174']
}

const uat = {
  API: {
        AUTH: 'https://qms-api-uat.azurewebsites.net/api',
        DATA: 'https://qms-api-uat.azurewebsites.net/api'
    },
    ORIGINS: ['https://staging.lowquotes.ie', 'https://qms-customer-uat.azurewebsites.net', 'https://app.lowquotes.ie', 'https://app.lowquotes.ie/services', 'https://hello.lowquotes.ie', 'https://truewealth.ie'],
    CLIENTAPP: ['https://qms-customer-uat.azurewebsites.net']
}

const prod = {
  API: {
        AUTH: 'https://qms-api-live.azurewebsites.net/api',
        DATA: 'https://qms-api-live.azurewebsites.net/api'
    },
    ORIGINS: ['https://lowquotes.ie', 'https://low.ie', 'https://truewealth.ie', 'http://sitepreviewer.ie', 'https://0joqgia.sitepreviewer.ie'],
    CLIENTAPP: ['https://qms-customer.azurewebsites.net']
}

const config = process.env.REACT_APP_STAGE === 'prod' ? prod
  : process.env.REACT_APP_STAGE === 'uat' ? uat
    : process.env.REACT_APP_STAGE === 'dev' ? dev
      : local;

const API_URL = config.API.DATA;
const AUTH_URL = config.API.AUTH;

export { API_URL, AUTH_URL };
export default config;
